import React from "react";
import { Link } from "react-router-dom";
import styles from "./ContactHeader.scss";
import ReactGA from "react-ga4";
import { PageRoute } from "../../../../../models";
import useHrPageName from "../../../../../utils/useHrPageName";
import RatingButton from "../../../../../components/RatingButton";
import RatingCounter from "../../../../../components/RatingCounter";
import { checkEmptyObject } from "../../../../../services";
import { IndexAvatar } from "../../../../../components";
import { getIconUrl } from "../../../../../services/asset";

const ContactHeader = ({ userAvatar, seller, category, adId }) => {
  const hrPageName = useHrPageName(category);
  const ratingsUrl = `${PageRoute.user}/${encodeURIComponent(seller.username)}${PageRoute.userRatings}`;
  const userAdsUrl = `${PageRoute.user}/${encodeURIComponent(seller.username)}`;

  return (
    <div className={styles.topSection}>
      {/* Header row: Avatar + Username/Rating/SellerLink + Chevron */}
      <Link to={ratingsUrl} className={styles.headerRow}>
        <IndexAvatar
          size={67}
          url={userAvatar}
          className={styles.avatar}
        />
        <div className={styles.headerContent}>
          <div className={styles.username}>{seller.username}</div>
          {checkEmptyObject(seller) && (
            <RatingCounter user={seller} />
          )}
          <Link
            to={userAdsUrl}
            className={styles.sellerLink}
            onClick={(e) => e.stopPropagation()}
          >
            Svi oglasi oglašivača
          </Link>
        </div>
        <img src={getIconUrl("chevron-right.svg")} alt="" className={styles.chevron} />
      </Link>

      {/* Rate button */}
      {checkEmptyObject(seller) && (
        <div className={styles.ratingButtonWrapper}>
          <RatingButton
            user={seller}
            adId={adId}
            gaLabel="Ocijeni - iz oglasa"
          />
        </div>
      )}
    </div>
  )
}

export default ContactHeader;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/ContactSection/ContactHeader/index.tsx